<template>
  <div>
    <div class="mb-2 flex" >
      <span>{{question.num}}. </span>
      <div v-html="question.content.richText"></div>
    </div>
    <div>
      <vote-search-content :question="question"/>
    </div>
  </div>
</template>

<script>
import VoteSearchContent from './Content'

export default {
  name: 'VoteSearch',
  components: { VoteSearchContent },
  props: {
    question: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>